import { FC, ReactNode } from "react";
import { useSelector } from "react-redux";
import { NavItemsConfig } from "./NavigationDrawer/DrawerConfiguration";
import NavigationDrawer from "../navigation/NavigationDrawer/NavigationDrawer";
import PageContentWrapper from "../../SolarGikLib/PageContentWrapper";
import Header from "./header/Header";
import { selectIsMultisiteAiChatEnabled } from "../chat/components/chatUtils";
import { RootState } from "../app/Store";

interface IMultisiteContentProps {
  children: ReactNode;
}
const MultisiteContent: FC<IMultisiteContentProps> = ({ children }) => {
  const userLevel = useSelector((state: RootState) => state.user.userType);
  const filteredDrawerItems = NavItemsConfig.filter((item) =>
    item.visibilityFilter({ userAccessType: userLevel })
  );
  const isAiChatEnabled = useSelector(selectIsMultisiteAiChatEnabled);
  return (
    <>
      <Header isAiChatEnabled={isAiChatEnabled} />
      <NavigationDrawer navigationItems={filteredDrawerItems} />
      <PageContentWrapper backgroundWindowStyle={{ marginRight: "20px" }}>{children}</PageContentWrapper>
    </>
  );
};

export default MultisiteContent;
